<template>
    <div
        v-show="showIcon"
        @click="showScoringPopup()"
        id="btnHeaderTao"
        class="tao-icon-wrapper"
    >
        <svg
            class="tao-icon"
            v-if="addInfoIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve" width="32" height="32" @click="showScoringPopup()">
                <g>
                    <g>
                        <g>
                            <path v-if ="decisionColor" class="st0" d="M20,40C9,40,0,31,0,20C0,9,9,0,20,0s20,9,20,20C40,31,31,40,20,40z" v-bind:style="{'fill': decisionColor }"/>
                            <path v-else class="st0 svg-primary-color" d="M20,40C9,40,0,31,0,20C0,9,9,0,20,0s20,9,20,20C40,31,31,40,20,40z" />
                        </g>
                    </g>
<!--                 SMASSDEV - 1045 .Here we need svg-on-primary-color because on high contrast there will be white on white or black on black.-->
                    <path class="svg-on-primary-color" d="M21.4,26.5v-8.4h-4.7v0.9h1.9v7.5h-1.9v0.9h6.5v-0.9H21.4z M20,15.3c0.8,0,1.4-0.6,1.4-1.4
                        c0-0.8-0.6-1.4-1.4-1.4s-1.4,0.6-1.4,1.4C18.6,14.7,19.2,15.3,20,15.3z"/>
                </g>
        </svg>
        <div class="tao-icon"  v-if="!addInfoIcon" id="decision-icon1" v-html="decisionItemIcon">
        </div>

        <div class="tao-text-wrapper hidden-sm-and-down">
            <span v-if="di1Name" id="textHeaderTaoDi1Name" class="tao-text upper-tao-text">
                {{ di1Name }}
            </span>
            <span v-if="di2Name" id="textHeaderTaoDi2Name" class="tao-text down-tao-text">
                {{ di2Name }}
            </span>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions} from 'vuex';

    export default {
        name: "infoIcon",
        data() {
            return {
                 decisionItemIcon: '',
                 colorTheme:''
            }
        },
        computed: {
            ...mapGetters({
                decisionItem: 'AssessmentAlertsStore/getDecisionItem',
                decisionColor: 'AssessmentAlertsStore/getDecisionColor',
                decisionIcon: 'AssessmentAlertsStore/getDecisionIcon',
                di1Name: 'AssessmentAlertsStore/getDi1Name',
                di2Name: 'AssessmentAlertsStore/getDi2Name',
                showIcon: 'AssessmentAlertsStore/getShowIcon',
                addInfoIcon: 'AssessmentAlertsStore/getAddInfoIcon',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                scoringPopupData: 'AssessmentAlertsStore/getScoringPopupData',
                getCurrentGuiThemeColor: 'ThemeStore/getCurrentGuiThemeColor'
            }),

        },
        methods: {
            ...mapActions({
                showScoringPopup: 'AssessmentAlertsStore/showScoringPopup'
            })
        },
        watch: {

            decisionIcon(newVal, oldVal) {
                if (newVal !== null && newVal.length > 0) {

                    if (newVal.includes('COLOR_PLACEHOLDER')){
                        if (this.decisionColor) {
                          this.decisionItemIcon = newVal.replace(/COLOR_PLACEHOLDER/gi, this.decisionColor.replace(/["']/g, ""));
                        }
                        else {
                           this.decisionItemIcon = newVal.replace(/COLOR_PLACEHOLDER/gi, this.getCurrentGuiThemeColor);
                        }
                     }
                    else {
                        this.decisionItemIcon = newVal;
                    }
                }

            },
            decisionColor(newVal, oldVal) {
                if (newVal && this.decisionIcon !== null && this.decisionIcon.length > 0) {

                    if (this.decisionIcon.includes('COLOR_PLACEHOLDER')){
                        if (this.decisionIcon) {
                            this.decisionItemIcon = this.decisionIcon.replace(/COLOR_PLACEHOLDER/gi, newVal.replace(/["']/g, ""));
                        }
                        else {
                            this.decisionItemIcon = this.decisionIcon.replace(/COLOR_PLACEHOLDER/gi, this.getCurrentGuiThemeColor);
                        }
                    }
                    else {
                        this.decisionItemIcon = this.decisionIcon;
                    }
                }
            }

        },
        mounted() {
            let primaryColor = this.getCurrentGuiThemeColor;
            this.colorTheme = primaryColor.replace(/['"]+/g, '');
        }

    }
</script>

<style scoped lang="scss">

.tao-icon-wrapper {
    display: flex;
    cursor: pointer;
    height: 40px;
    border: 1px solid $color-element-outline;
    padding: 10px;
    align-items: center;
    width: auto;
    border-radius: 40px;
    margin-right: 8px;
}


.tao-icon {
    width: 32px;
    height: 32px;
    border-radius: 11px;

    svg {
        width: 32px !important;
        height: 32px !important;
    }
}
.tao-text-wrapper {
    display: flex;
    flex-direction: column;
    width: auto;
    margin-right: 20px;
    margin-left: 10px;
    // SMASSDEV - 1119
    font-size: $font-size-small;
    // word-spacing: $word-spacing-small;
    // line-height: $line-height-small;
    // letter-spacing: $letter-spacing-small;
}
.tao-text:only-child {
    margin-top: -2px;
}
.tao-text {
    max-height: 18px;
}

.upper-tao-text {
    font-weight: $font-weight-bold;
    white-space: nowrap;
}
.down-tao-text {
    font-weight: $font-weight-light;
    white-space: nowrap;
}


@media (max-width: 960px) {
    .tao-icon-wrapper {
        padding: 8px;
    }
}

</style>




// WEBPACK FOOTER //
// src/common/components/svg/topBarAlerts/infoIcon.vue